/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, EventEmitter, Input, Output} from '@angular/core';

import {LotRemovalEvent, TenureRemovalEvent} from '../tenure.service';
import {ControlContainer, NgForm} from '@angular/forms';
import {PDF_CREATION_METHOD} from "../../../common/constants";

@Component({
    selector: 'nlr-former-tenure',
    imports: [],
    templateUrl: './former-tenure.component.html',
    styleUrl: './former-tenure.component.scss',
    viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class FormerTenureComponent {
    @Input() summaryViewModel: any;
    @Input() dataLabelMap: any;
    @Input() pdfCreationMethod: string;
    @Input() removeTenureDisabled: boolean;
    @Input() removeLotDisabled: boolean = false;
    @Output() dataRemoveLot = new EventEmitter<LotRemovalEvent>();
    @Output() dataRemoveTenure = new EventEmitter<TenureRemovalEvent>();
    tenureSummary: any;
    removeLot(tenureIndex: number, lotIndex: number): void {
        this.dataRemoveLot.emit({tenureIndex: tenureIndex, lotIndex: lotIndex});
    }

    removeTenure(tenureIndex: number): void {
        this.dataRemoveTenure.emit({tenureIndex: tenureIndex});
    }

    isDigitalOrPortalPlan() {
        return this.pdfCreationMethod === PDF_CREATION_METHOD.DIGITAL_PLAN || this.pdfCreationMethod === PDF_CREATION_METHOD.SURVEYOR_PORTAL;
    }
}
